import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldTypeConfig, FieldType, FormlyFieldProps } from '@ngx-formly/core';

interface SectionHeaderProps extends FormlyFieldProps {
  helpText?: string;
  helpUrl?: string;
}

@Component({
  standalone: false,
  selector: 'formly-field-section-header',
  templateUrl: './section-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlySectionHeader extends FieldType<
  FieldTypeConfig<SectionHeaderProps>
> {}
